import React from 'react';
import {
  SpinnerBlock,
  SpinnerOverlay,
  InnerSpinner,
  Dot,
  LoadingText,
} from './styledComponents';

function Spinner() {
  return (
    <SpinnerBlock>
      <SpinnerOverlay>
        <InnerSpinner>
          <Dot>&nbsp;</Dot>
          <Dot className="dot2">&nbsp;</Dot>
        </InnerSpinner>
        <LoadingText>Loading</LoadingText>
      </SpinnerOverlay>
    </SpinnerBlock>
  );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js